/* The Find Club — theme script */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (cents) {
    var fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: fmt }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.reveal, .split-line, [data-reveal]');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });

    document.querySelectorAll('[data-stagger]').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        child.style.setProperty('--d', (i * 0.09).toFixed(2) + 's');
      });
    });
  }

  /* ---------- Count-up numbers ---------- */
  function initCounters() {
    var nums = document.querySelectorAll('[data-count]');
    if (!nums.length) return;
    var run = function (el) {
      var end = parseFloat(el.getAttribute('data-count')) || 0;
      var suffix = el.getAttribute('data-suffix') || '';
      if (reduce) { el.textContent = end.toLocaleString() + suffix; return; }
      var start = null, dur = 1800;
      var step = function (ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 4);
        el.textContent = Math.round(end * eased).toLocaleString() + suffix;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { nums.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.6 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (header) {
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    var nav = document.querySelector('[data-mobile-nav]');
    document.querySelectorAll('[data-menu-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        nav.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        var first = nav.querySelector('a, button');
        if (first) first.focus();
      });
    });
    document.querySelectorAll('[data-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        nav.classList.remove('is-open');
        document.body.style.overflow = '';
        var opener = document.querySelector('[data-menu-open]');
        if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav && nav.classList.contains('is-open')) {
        var c = nav.querySelector('[data-menu-close]'); if (c) c.click();
      }
    });
  }

  /* ---------- Parallax ---------- */
  function initParallax() {
    var items = document.querySelectorAll('[data-parallax]');
    if (!items.length || reduce) return;
    var ticking = false;
    var update = function () {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.1;
        var offset = (r.top + r.height / 2 - vh / 2) * -speed;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Cart helpers ---------- */
  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
      setTimeout(function () { el.classList.remove('bump'); }, 350);
    });
  }
  function toast(html) {
    var t = document.querySelector('[data-toast]');
    if (!t) return;
    t.innerHTML = html;
    t.classList.add('is-visible');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('is-visible'); }, 4200);
  }

  function initAjaxForms() {
    document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btns = document.querySelectorAll('[data-atc]');
        btns.forEach(function (b) { b.classList.add('is-loading'); });
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            btns.forEach(function (b) { b.classList.remove('is-loading'); });
            if (!res.ok) { toast(res.data.description || 'Could not add to cart.'); return; }
            btns.forEach(function (b) {
              var label = b.querySelector('[data-atc-label]');
              var prev = label ? label.textContent : '';
              b.classList.add('is-added');
              if (label) label.textContent = 'Added';
              setTimeout(function () { b.classList.remove('is-added'); if (label) label.textContent = prev; }, 2000);
            });
            return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              setCartCount(cart.item_count);
              toast('Added to your cart <a href="/cart">View cart</a>');
            });
          })
          .catch(function () {
            btns.forEach(function (b) { b.classList.remove('is-loading'); });
            form.submit();
          });
      });
    });
  }

  /* ---------- Product ---------- */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form[data-ajax-cart]');
    var idInput = form && form.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var saveEl = root.querySelector('[data-save]');
    var atcLabels = document.querySelectorAll('[data-atc-label]');
    var atcBtns = document.querySelectorAll('[data-atc]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyVariant = document.querySelector('[data-sticky-variant]');

    /* Gallery */
    var slides = root.querySelectorAll('.gallery__slide');
    var thumbs = root.querySelectorAll('.gallery__thumb');
    var countEl = root.querySelector('[data-gallery-count]');
    var current = Math.max(0, Array.prototype.findIndex.call(slides, function (s) { return s.classList.contains('is-active'); }));
    function show(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === current); });
      thumbs.forEach(function (t, n) {
        t.setAttribute('aria-current', n === current ? 'true' : 'false');
        if (n === current && t.scrollIntoView) {
          var bar = t.parentElement;
          bar.scrollTo({ left: t.offsetLeft - bar.clientWidth / 2 + t.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
        }
      });
      if (countEl) countEl.textContent = (current + 1) + ' / ' + slides.length;
      var main = root.querySelector('.gallery__main');
      if (main) main.classList.remove('is-zoomed');
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    var main = root.querySelector('.gallery__main');
    if (main) {
      var sx = null;
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
        sx = null;
      });
      main.addEventListener('click', function (e) {
        if (window.matchMedia('(hover: none)').matches) return;
        var r = main.getBoundingClientRect();
        main.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
        main.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
        main.classList.toggle('is-zoomed');
      });
      main.addEventListener('mousemove', function (e) {
        if (!main.classList.contains('is-zoomed')) return;
        var r = main.getBoundingClientRect();
        main.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
        main.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
      });
      main.addEventListener('mouseleave', function () { main.classList.remove('is-zoomed'); });
    }
    if (countEl && slides.length) countEl.textContent = (current + 1) + ' / ' + slides.length;
    if (slides.length && slides.length > 1 && !reduce) {
      var auto = setInterval(function () { show(current + 1); }, 5200);
      ['pointerdown', 'focusin', 'keydown'].forEach(function (ev) {
        root.querySelector('.gallery').addEventListener(ev, function () { clearInterval(auto); }, { once: true });
      });
    }

    /* Options */
    var fieldsets = root.querySelectorAll('[data-option-index]');
    function selected() {
      var vals = [];
      fieldsets.forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        vals[parseInt(fs.getAttribute('data-option-index'), 10)] = c ? c.value : null;
      });
      return vals;
    }
    function findVariant(vals) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === vals[i]; });
      });
    }
    function markAvailability(vals) {
      fieldsets.forEach(function (fs) {
        var idx = parseInt(fs.getAttribute('data-option-index'), 10);
        fs.querySelectorAll('input').forEach(function (inp) {
          var test = vals.slice(); test[idx] = inp.value;
          var exists = product.variants.some(function (v) {
            return v.options.every(function (o, i) { return o === test[i]; });
          });
          inp.classList.toggle('is-unavailable', !exists);
        });
      });
    }
    function update() {
      var vals = selected();
      fieldsets.forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        var out = fs.querySelector('[data-option-value]');
        if (out && c) out.textContent = c.value;
      });
      markAvailability(vals);
      var v = findVariant(vals);
      if (!v) {
        atcBtns.forEach(function (b) { b.disabled = true; });
        atcLabels.forEach(function (l) { l.textContent = 'Unavailable'; });
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        priceEl.classList.add('is-changing');
        setTimeout(function () { priceEl.textContent = money(v.price); priceEl.classList.remove('is-changing'); }, 180);
      }
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (stickyVariant) stickyVariant.textContent = v.title;
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false;
          if (saveEl) { saveEl.textContent = 'Save ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; saveEl.hidden = false; }
        } else {
          compareEl.hidden = true; if (saveEl) saveEl.hidden = true;
        }
      }
      atcBtns.forEach(function (b) { b.disabled = !v.available; });
      atcLabels.forEach(function (l) { l.textContent = v.available ? 'Add to cart' : 'Sold out'; });
      if (v.featured_media) {
        var idx = Array.prototype.findIndex.call(slides, function (s) { return s.getAttribute('data-media-id') == v.featured_media.id; });
        if (idx > -1) show(idx);
      }
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
      document.dispatchEvent(new CustomEvent('findclub:variant', { detail: v }));
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
    if (fieldsets.length) markAvailability(selected());

    /* Quantity */
    root.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(input.value, 10) || 1;
          input.value = Math.max(1, n + (b.hasAttribute('data-plus') ? 1 : -1));
        });
      });
    });

    /* Sticky add to cart */
    var sticky = document.querySelector('[data-sticky-atc]');
    var mainBtn = root.querySelector('[data-atc-main]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var past = e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', !e.isIntersecting && past);
          sticky.setAttribute('aria-hidden', (!(!e.isIntersecting && past)).toString());
        });
      });
      io.observe(mainBtn);
      var stickyBtn = sticky.querySelector('[data-sticky-submit]');
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }
  }

  /* ---------- LED showcase ---------- */
  function initLED(root) {
    var stage = root;
    var swatches = root.querySelectorAll('[data-led-color]');
    var modeBtns = root.querySelectorAll('[data-led-mode]');
    var picker = root.querySelector('[data-led-picker]');
    var timer = null, hue = 0;
    function set(c) { stage.style.setProperty('--led', c); }
    function press(list, el) { list.forEach(function (b) { b.setAttribute('aria-pressed', b === el ? 'true' : 'false'); }); }
    function stop() { clearInterval(timer); timer = null; }
    function cycle(speed) {
      stop();
      if (reduce) { set('hsl(200 90% 60%)'); return; }
      timer = setInterval(function () { hue = (hue + 2) % 360; set('hsl(' + hue + ' 92% 58%)'); }, speed);
    }
    swatches.forEach(function (b) {
      b.addEventListener('click', function () { stop(); press(modeBtns, null); press(swatches, b); set(b.getAttribute('data-led-color')); });
    });
    modeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        press(swatches, null); press(modeBtns, b);
        var m = b.getAttribute('data-led-mode');
        if (m === 'cycle') cycle(60);
        if (m === 'party') cycle(14);
      });
    });
    if (picker) picker.addEventListener('input', function () { stop(); press(swatches, null); press(modeBtns, null); set(picker.value); });

    /* Start cycling when in view, pause off-screen */
    if ('IntersectionObserver' in window) {
      var started = false;
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting && !started) {
            started = true;
            var first = root.querySelector('[data-led-mode="cycle"]');
            if (first) first.click();
          } else if (!e.isIntersecting && timer) {
            stop(); started = false;
          }
        });
      }, { threshold: 0.3 });
      io.observe(root);
    }
  }

  /* ---------- Fireplace ---------- */
  var FLAME = {
    amber: { f1: '#ffd166', f2: '#ff7b00', f3: 'rgba(214,40,40,0)', ember: '#ff5e1a', glow: 'rgba(255,120,30,.6)' },
    blue: { f1: '#d6f3ff', f2: '#2f8cff', f3: 'rgba(60,40,200,0)', ember: '#3a7bff', glow: 'rgba(60,130,255,.55)' },
    violet: { f1: '#ffd6ff', f2: '#b14cff', f3: 'rgba(120,20,160,0)', ember: '#c04bff', glow: 'rgba(180,80,255,.55)' },
    mixed: { f1: '#fff1a8', f2: '#ff4f9a', f3: 'rgba(60,100,255,0)', ember: '#ff4f9a', glow: 'rgba(255,90,160,.5)' }
  };
  function initFire(root) {
    var box = root.querySelector('.fire__box');
    var flames = root.querySelector('.flames');
    if (flames && !flames.children.length) {
      for (var i = 0; i < 9; i++) {
        var f = document.createElement('span');
        f.className = 'flame';
        f.style.setProperty('--h', (45 + Math.round(Math.sin(i / 8 * Math.PI) * 45)) + '%');
        f.style.animationDelay = (-Math.random() * 2).toFixed(2) + 's';
        flames.appendChild(f);
      }
    }
    if (box && !reduce) {
      for (var s = 0; s < 14; s++) {
        var sp = document.createElement('span');
        sp.className = 'spark';
        sp.style.setProperty('--x', (15 + Math.random() * 70).toFixed(0) + '%');
        sp.style.setProperty('--dx', ((Math.random() - .5) * 80).toFixed(0) + 'px');
        sp.style.setProperty('--s', (2 + Math.random() * 2.5).toFixed(2) + 's');
        sp.style.setProperty('--dl', (Math.random() * 4).toFixed(2) + 's');
        box.appendChild(sp);
      }
    }
    var chips = root.querySelectorAll('[data-flame]');
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var p = FLAME[c.getAttribute('data-flame')] || FLAME.amber;
        root.style.setProperty('--f1', p.f1); root.style.setProperty('--f2', p.f2); root.style.setProperty('--f3', p.f3);
        root.style.setProperty('--ember', p.ember); root.style.setProperty('--flame-glow', p.glow);
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
      });
    });
    var range = root.querySelector('[data-brightness]');
    var out = root.querySelector('[data-brightness-out]');
    if (range) {
      var apply = function () {
        var v = parseInt(range.value, 10);
        root.style.setProperty('--bright', (0.2 + v * 0.16).toFixed(2));
        range.style.setProperty('--p', ((v - 1) / 4 * 100) + '%');
        if (out) out.textContent = 'Level ' + v + ' of 5';
      };
      range.addEventListener('input', apply); apply();
    }
    var timerChips = root.querySelectorAll('[data-timer]');
    var ring = root.querySelector('[data-timer-ring]');
    var tOut = root.querySelector('[data-timer-out]');
    timerChips.forEach(function (c) {
      c.addEventListener('click', function () {
        var h = parseInt(c.getAttribute('data-timer'), 10);
        timerChips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        if (ring) { var len = 2 * Math.PI * 26; ring.style.strokeDasharray = len; ring.style.strokeDashoffset = len * (1 - h / 8); }
        if (tOut) tOut.textContent = h + (h === 1 ? ' hour' : ' hours');
      });
    });
    var firstTimer = root.querySelector('[data-timer][aria-pressed="true"]');
    if (firstTimer) firstTimer.click();
  }

  /* ---------- Boot ---------- */
  function boot() {
    initReveal();
    initCounters();
    initHeader();
    initParallax();
    initAjaxForms();
    document.querySelectorAll('[data-product]').forEach(initProduct);
    document.querySelectorAll('[data-led]').forEach(initLED);
    document.querySelectorAll('[data-fire]').forEach(initFire);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    e.target.querySelectorAll('[data-product]').forEach(initProduct);
    e.target.querySelectorAll('[data-led]').forEach(initLED);
    e.target.querySelectorAll('[data-fire]').forEach(initFire);
  });
})();
